export const site = {
  name: "513吃瓜",
  slogan: "追梗不迷路，吃瓜有后续",
  description:
    "513吃瓜是面向年轻网民的热梗聚合社区，专注整理网络热梗的来龙去脉、衍生表情包、二创二改作品与评论区神评，让你一次看完全部后续。",
  email: "hello@513chigua.com",
  wechat: "chigua513",
  workingHours: "每天 09:00 - 23:00（节假日不休）",
  foundedYear: "2023",
  counts: {
    topics: "3,800+",
    memes: "12,600+",
    creators: "240+",
    daily: "86万",
  },
  nav: [
    { key: "home", label: "首页", path: "/" },
    { key: "topics", label: "热梗库", path: "/topics" },
    { key: "memes", label: "表情包专区", path: "/memes" },
    { key: "about", label: "关于我们", path: "/about" },
    { key: "faq", label: "常见问题", path: "/faq" },
    { key: "contact", label: "联系我们", path: "/contact" },
  ],
  hotWords: [
    "后续梗追踪",
    "表情包出处",
    "二创二改",
    "评论区神评",
    "台词出处",
    "模仿名场面",
    "热梗生命周期",
    "AI 玩梗",
    "土味情话进化",
    "打工人文学",
  ],
};